import React from 'react';
import LegalLayout from './LegalLayout';
import {CONTACT_EMAIL} from '../siteConfig';

function TermsPage() {
  return (
    <LegalLayout kicker="Legal" title="Terms of Service" updated="October 18, 2026">
      <p>
        These terms apply when you use the Handle My Tech website, client app and services. By signing up or using our services, you agree to them.
      </p>

      <h2>Our services</h2>
      <p>
        Handle My Tech sets up, runs and supports technology services for local businesses, such as missed-call text-back, chat and voice receptionists, online booking and reminders, review management, invoicing and payments, email and social posting, and websites. What is included is set out in your quote; see our <a href="#/services">services</a> and <a href="#/pricing">pricing</a> pages.
      </p>

      <h2>Your account</h2>
      <p>
        You are responsible for keeping your login details safe and for activity on your account. Please give us accurate information and keep it up to date.
      </p>

      <h2>Payments and cancellation</h2>
      <p>
        Services are billed monthly at the prices in your quote. Any one-time setup fees are listed in your quote before you commit. There is no long-term contract, and you can cancel anytime; please email us before you cancel so we can hand over or wind down each service cleanly.
      </p>

      <h2>Your content</h2>
      <p>
        You keep ownership of the content you add to your website and app. You give us permission to host, display and back it up so we can provide the service. You are responsible for making sure you have the right to use it.
      </p>

      <h2>Acceptable use</h2>
      <p>
        Do not use our services for anything unlawful, to send spam, to infringe on others&apos; rights, or to interfere with the service or other customers.
      </p>

      <h2>SMS terms</h2>
      <p>
        By opting in, you agree to receive text messages from Handle My Tech about your inquiries, appointments and service updates. Message frequency varies. Message and data rates may apply. Reply STOP to opt out at any time, or HELP for help. Carriers are not liable for delayed or undelivered messages. Consent to receive texts is not a condition of purchase. See our <a href="#/privacy">Privacy Policy</a> for how we handle your information.
      </p>

      <h2>Disclaimers</h2>
      <p>
        We work to keep our services available and running well, but they are provided &quot;as is&quot; and we cannot promise they will be uninterrupted or error-free.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the extent the law allows, Handle My Tech is not liable for indirect or consequential losses, and our total liability for any claim is limited to the amount you paid us in the three months before the claim.
      </p>

      <h2>Changes to these terms</h2>
      <p>If we change these terms, we will update the date at the top of this page.</p>

      <h2>Governing law</h2>
      <p>These terms are governed by the laws of the State of Arizona.</p>

      <h2>Contact us</h2>
      <p>
        Questions about these terms? Email <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalLayout>
  );
}

export default TermsPage;
